module.exports = __webpack_public_path__ + "img/flag-fill.d14c79ef.svg";